var _style, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResyUnlockIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "Resy_Unlock_Icon_svg__Layer_1",
  viewBox: "5 8 40 35",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Resy_Unlock_Icon_svg__clippath"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.1 6.6h27.7v17H11.1z",
  style: {
    fill: "none"
  }
})), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Resy_Unlock_Icon_svg__st1,.Resy_Unlock_Icon_svg__st2{fill:none}.Resy_Unlock_Icon_svg__st1{stroke:#000}.Resy_Unlock_Icon_svg__st1,.Resy_Unlock_Icon_svg__st2{stroke-linejoin:round;stroke-width:1.5px}.Resy_Unlock_Icon_svg__st3{fill:#ea553c}.Resy_Unlock_Icon_svg__st2{stroke:#ea553c}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M35.2 25.9v15",
  className: "Resy_Unlock_Icon_svg__st2"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.2 27.2v-8.9c0-4.5 3.5-8.2 7.7-8.2s7.7 3.7 7.7 8.2V21",
  className: "Resy_Unlock_Icon_svg__st1",
  style: {
    clipPath: "url(#Resy_Unlock_Icon_svg__clippath)"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 31.9v8.5c0 1.7 1.3 3 3 3h20.4c1.7 0 3-1.3 3-3v-17H13.9",
  className: "Resy_Unlock_Icon_svg__st1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7 22.1c.1 2.3 2 4.2 4.3 4.3-2.3.1-4.2 2-4.3 4.3-.1-2.3-2-4.2-4.3-4.3 2.3-.1 4.2-2 4.3-4.3M9.1 19.8c-.4.6-.4 1.4 0 2-.6-.4-1.4-.4-2 0 .4-.6.4-1.4 0-2 .6.4 1.4.4 2 0M11.7 15.6c.2 1 .9 1.8 1.9 1.9-1 .2-1.8.9-1.9 1.9-.2-1-.9-1.8-1.9-1.9 1-.2 1.8-.9 1.9-1.9",
  className: "Resy_Unlock_Icon_svg__st3"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 25.2,
  cy: 33.4,
  r: 1.9,
  className: "Resy_Unlock_Icon_svg__st3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.2 33.3h-4",
  className: "Resy_Unlock_Icon_svg__st2"
})));
export default SvgResyUnlockIcon;